import React, { PureComponent } from "react";

class AnimatedList extends PureComponent{
	constructor() {
		super();
		this.state = {
			currentIndex: 0
		};
		this.timerId = null;
	};
	
	componentWillUnmount() {
		clearInterval(this.timerId);
	};
	
	componentWillReceiveProps(nextProps) {
		const { isVisible } = this.props;
		if (nextProps.isVisible && !isVisible) {
			this.startTimer();
		} else if (!nextProps.isVisible && isVisible) {
			this.stopTimer(this.state.currentIndex);
		}
	}
	
	playNext = () => {
		let { currentIndex } = this.state;
		let { listDataLength, onIndexChanged } = this.props;
		currentIndex = (currentIndex + 1) % listDataLength;
		this.setState({
			currentIndex
		});
		if (onIndexChanged) {
			onIndexChanged(currentIndex);
		}
	};
	
	stopTimer = (index) => {
		let { onIndexChanged } = this.props;
		if (this.timerId) {
			clearInterval(this.timerId);
			this.timerId = null;
			this.setState({
				currentIndex: index
			});
			if (onIndexChanged) {
				onIndexChanged(index);
			}
			
		}
	};
	
	startTimer = () => {
		if (this.timerId) {
			clearInterval(this.timerId);
		}
		this.timerId = setInterval(this.playNext, 3000);
	};
	
	render() {
		const { currentIndex } = this.state;
		return (
			<div>
				{
					React.cloneElement(this.props.children, {
						currentIndex: currentIndex,
						startTimer: this.startTimer,
						stopTimer: this.stopTimer,
						...this.props
					})
				}
			</div>
		);
	}
}

export default AnimatedList;



// WEBPACK FOOTER //
// ./src/components/LandingAnimatedList/AnimatedList.js